import { useContext } from 'react';
import { ConfirmDialogV2Context } from '../components/confirm-dialog-v2/ConfirmDialogV2Provider';

export default function useConfirmV2() {
  return useContext(ConfirmDialogV2Context);
}
